import StyleGuide from './styleGuide';
export default StyleGuide;
